import isEqualWith from 'lodash/isEqualWith';

const ignoredTypes = ['function', 'FiberNode'];

const ignoreType = (obj) => {
  let type = typeof obj;

  if (type === 'object' && obj !== null && obj.constructor) {
    type = obj.constructor.name;
  }

  return ignoredTypes.indexOf(type) !== -1;
};

const customizer = (obj, other) => {
  if (ignoreType(obj)) {
    return true;
  }

  if (obj === other) return true;
  if (
    (obj === null || obj === undefined || obj === '' || obj === false) &&
    (other === null || other === undefined || other === '' || other === false)
  )
    return true;

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
};

const deepEqual = (a, b) => isEqualWith(a, b, customizer);

export default deepEqual;
